import { parse, format, isValid } from "date-fns";

/**
 * Converts date string from 'DD-MM-YYYY' to 'YYYY-MM-DD'.
 *
 * @param {string} dateString - The date string in 'DD-MM-YYYY' format.
 * @returns {string} - The date string in 'YYYY-MM-DD' format.
 */
export function convertDateStringDDMMYYYYtoYYYYMMDD(dateString) {
  if (!dateString) {
    return "";
  }

  // Parse it into a Date object using date-fns
  const parsedDate = parse(dateString, "dd-MM-yyyy", new Date());
  // Format the Date object to YYYY-MM-DD
  return format(parsedDate, "yyyy-MM-dd");
}

/**
 * Checks if a string is a valid date in the 'DD-MM-YYYY' format.
 *
 * @param {string} dateString - The candidate date string.
 * @returns {boolean} - `true` if valid; otherwise `false`.
 */
export function isValidDateDDMMYYYY(dateString) {
  if (typeof dateString !== "string") return false;

  // Optional: quick regex check for basic format 'DD-MM-YYYY'
  // This ensures we only parse strings with two digits, dash, two digits, dash, four digits
  const basicPattern = /^\d{2}-\d{2}-\d{4}$/;
  if (!basicPattern.test(dateString)) {
    return false;
  }

  // Parse using date-fns
  const parsedDate = parse(dateString, "dd-MM-yyyy", new Date());

  // Check if the parsed date is valid
  if (!isValid(parsedDate)) {
    return false;
  }

  // Finally, reformat it back as 'DD-MM-YYYY' and compare
  // This ensures something like '31-02-2023' won't slip by
  const reFormatted = format(parsedDate, "dd-MM-yyyy");
  return reFormatted === dateString;
}
